import { call, put, takeEvery} from "redux-saga/effects";

import { LOGIN_USER, LOGIN_USER_BY_TOKEN, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

import BizinBackend from "../../../helpers/bizin_helper";

import { isLoading } from "../../actions";

let errorMessage = 'Erro ao fazer login';

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "bizin") {
     
      const response = yield call(BizinBackend.loginUser, user.email, user.password, user._csrf );

      if(typeof response === 'undefined' || response?.message) { 
        yield put(apiError(response?.message || errorMessage))
      }else{
        localStorage.setItem("authUser", JSON.stringify(response));
        yield put(loginSuccess(response, response?.resultset_2[0]));
      }
      
    }else console.log("REACT_APP_DEFAULTAUTH not found")
    yield put(isLoading(false))
  } catch (error) {
    console.log(error)
    if (error.response) {
      if (error.response.data && typeof error.response.data === 'object') {
        if (Array.isArray(error.response.data.data)) {
          const errorData = error.response.data.data[0];
          errorMessage = errorData && errorData.message ? errorData.message : errorMessage;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
    }
    yield put(isLoading(false))
    yield put(apiError(errorMessage));
  }
}

function* loginUserByToken({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "bizin") {
     
      const response = yield call(BizinBackend.loginUserByToken, user.email, user.token, user._csrf);

      if(typeof response === 'undefined') { 
        yield put(apiError(errorMessage)) 
        return;
      }
      
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response, response?.resultset_2[0]));
    }
    yield put(isLoading(false))
  } catch (error) {
    console.log(error)
    if (error.response) {
      if (error.response.data && typeof error.response.data === 'object') {
        if (Array.isArray(error.response.data.data)) {
          const errorData = error.response.data.data[0];
          errorMessage = errorData && errorData.message ? errorData.message : errorMessage;
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
    }
    yield put(isLoading(false))
    yield put(apiError(errorMessage));
  }
}

function* logoutUser() {
  try {
    localStorage.removeItem("authUser");
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGIN_USER_BY_TOKEN, loginUserByToken);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
